import { DateTimestamp, FirebaseTimestamp, IRecord } from '@triggered/common';

export interface IReportSettings extends IRecord {
  reports: {[reportId: string ]: {
    lastRun: DateTimestamp | FirebaseTimestamp;
  }}

}
